module.exports = __webpack_public_path__ + "img/28.84f09a40.png";